<template>
    <sp-form
        class="mobile-general-form-city-picker"
        :class="[`uuid-${config.uuid} ${globalModel.preview ? 'preview-text' : ''}`, `${notChanged ? 'disable-opacity' : ''}`]"
        ref="elForm"
        v-show="!props.hide"
        :model="formModel"
        :rules="rules"
    >
        <sp-form-item prop="pickerValue">
            <div @click="onClickForm">
                <sharp-comp-select
                    v-if="!globalModel.preview"
                    :label="i18nLabel"
                    :is-required="props.required || props.requiredCity"
                    :selected-options-text="selectedOptionsText"
                    @click="onClick"
                    :placeholder="i18n(props.placeholder)"
                    :disabled="notChanged"
                ></sharp-comp-select>

                <!-- 预览时的效果 -->
                <PreviewText
                    v-else
                    :labelText="i18nLabel"
                    :textDesc="selectedOptionsText"
                    @click="onClickForm"
                ></PreviewText>
            </div>
        </sp-form-item>
    </sp-form>
</template>
<script>
import { Form, FormItem } from '@ks/sharp-ui';
import SharpCompSelect from '@ks/sharp-comp-form-select';
import '@ks/sharp-comp-form-select/lib/themes/default/index.css';
import isEqual from 'lodash/isEqual';
import ComponentBase from '../component-base';
import { component } from './props';
import { selectCity } from './picker';
import PreviewText from '../component-base/common/preview-text';

export default {
    name: component,
    components: {
        SpForm: Form,
        SpFormItem: FormItem,
        SharpCompSelect,
        PreviewText,
    },
    extends: ComponentBase,
    data() {
        return {
            formModel: {
                pickerValue: null,
            },
        };
    },
    mounted() {
        // 检测一次就够了
        this.checkKsBridge();
    },
    computed: {
        rules() {
            const otherRules = [
                {
                    validator: (rule, value = null, callback) => {
                        if (this.props.requiredCity) {
                            // 如果开启了城市必选
                            if (value && value.cityName) {
                                return callback();
                            }
                            const errMsg = this.i18n(this.props.errRequiredCity || '必须选择一个城市');
                            return callback(new Error(errMsg));
                        }
                        return callback();
                    },
                },
            ];
            return {
                pickerValue: this.composeRules(this.props, { otherRules }),
            };
        },
        selectedOptionsText() {
            return this.formModel.pickerValue
                ? `${this.formModel.pickerValue.provinceName} ${this.formModel.pickerValue.cityName}`
                : '';
        },
    },
    methods: {
        async checkKsBridge() {
            this.$nextTick(() => {
                this.$emit('no-ks-bridge');
            });
        },
        async onClick() {
            try {
                const ret = await selectCity();
                if (ret.provinceName || ret.cityName) {
                    // 用户选择了省或市则记录值
                    this.onPick(ret);
                } else {
                    // 否则按清空处理
                    this.onPick(null);
                }
            } catch (e) {
                // do nothing
            }
        },
        onPick($event) {
            this.formModel.pickerValue = {
                ...$event,
                value: `${$event ? $event.provinceName : ''} ${$event ? $event.cityName : ''}`,
            };
            // console.log('[zy] onPick', this.formModel.pickerValue);
            // cityCode: "110116"
            // cityName: "怀柔区"
            // code: "110116"
            // provinceName: "北京"
            this.onPickerValueChange();
            this.$emit('user-input');
        },
        onPickerValueChange() {
            const res = this.setSelfFormDataValue(this.formModel.pickerValue);
            if (res) {
                // 数据修改成功，抛出change事件，触发依赖
                this.$emit('change');
            }
        },
        /**
         * 以下是组件公共方法的实现
         */
        dataChangeHandler() {
            const newValue = this.getSelfFormDataValue();
            if (typeof newValue !== 'object') {
                // 默认值逻辑
                if (this.formModel.pickerValue) {
                    this.formModel.pickerValue = null;
                }
                this.onPickerValueChange();
                // this.validate();
                return;
            }

            if (!isEqual(this.formModel.pickerValue, newValue)) {
                this.formModel.pickerValue = newValue;
                // 数据被动修改同样抛出change事件
                this.$emit('change');
                // this.validate();
            }
        },
        async validate() {
            if (this.skipValidate()) {
                return true;
            }
            const promise = new Promise((resolve, reject) => {
                this.$refs.elForm.validate((valid, invalidFields) => {
                    valid ? resolve(valid) : reject(invalidFields);
                });
            });
            try {
                return await promise;
            } catch (e) {
                this.validateFailureHandler(e.pickerValue[0].message);
                return false;
            }
        },
        clearValidate() {
            this.$refs.elForm.clearValidate();
        },
    },
};
</script>

<style lang="less" scoped>
@import '../../style.less';
</style>